export { DesktopView } from './DesktopView';
export { MobileView } from './MobileView';
export { PsychologistStepSkeleton } from './PsychologistStepSkeleton';

export const PSYCHOLOGISTS_KEY_PREFIX = 'AppointmentsReserve.Steps.psychologist.';
